import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/cyber-security.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Protect your Digital World with SAN micron"
				breadcrumbText="Cyber Security"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}